import { combineReducers } from "redux";
import { LoginReducer } from "./reducers/LoginReducers";
import {RatReducer} from './reducers/RatReducer';
import {GuestReducers}from './reducers/GuestReducer';
import {PaymentReducer} from './reducers/PaymentReducer';
const reducers = combineReducers({
    loginUser:LoginReducer,
    buildings:RatReducer,
    GuestInfo:GuestReducers,
    payments:PaymentReducer,
});
export default reducers;